import { QueryKey, useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import {
  getListingFunnel,
  ListingFunnelResponse,
} from 'api/admin/listing/getListingFunnel'

export const listingFunnelKey = (
  listingId: number,
  timeRange: { startDate: string; endDate: string }
) => ['listing-funnel', listingId, timeRange] as const

export const useListingFunnelQuery = (
  listingId: number,
  timeRange: { startDate: string; endDate: string }
) => {
  return useQuery<
    ListingFunnelResponse,
    AxiosError,
    ListingFunnelResponse,
    QueryKey
  >({
    queryKey: listingFunnelKey(listingId, timeRange),
    queryFn: () => getListingFunnel(listingId, timeRange),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: Boolean(listingId && timeRange.startDate && timeRange.endDate),
  })
}
